import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.reviewops.red.flag.list');
import { Input } from '@angular/core';

interface Signal {
    id: string;
    title: string;
    description: string;
}

interface RedFlag extends Signal {
    type: string;
    severity: string;
}

interface TrendData {
    positive_signals?: Signal[];
}

@Component({
    selector: 'wiz-component-reviewops-red-flag-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.reviewops.red.flag.list/view.scss */
/* src/app/component.reviewops.red.flag.list/view.scss: no such file or directory */`],
})
export class ComponentReviewopsRedFlagListComponent {
    @Input() redFlags: RedFlag[] = [];
    @Input() trendAnalysis: TrendData = {};

    public severityClass(severity: string): string {
        if (severity === 'critical') return 'bg-rose-600 text-white';
        if (severity === 'high') return 'bg-rose-100 text-rose-800';
        if (severity === 'moderate') return 'bg-amber-100 text-amber-800';
        return 'bg-orange-100 text-orange-800';
    }
}

export default ComponentReviewopsRedFlagListComponent;